import Http from '@/services/http';
import {
  AssetsRelationPagedRequest,
  AssetsRelationPagedResponse,
  AssetsRelationRequest,
  AssetTypes,
} from 'sigma-mappings';

const urls = {
  excel: '/ativo/exportar/excel',
  getReports: assetType => `/ativo/relacao/${assetType}`,
};

/* istanbul ignore next */
const errorHandler = {
  errorHandling: {
    responseMessageParams: {
      $MA009: data => data,
    },
  },
};

export default {
  getAssets(assetType, payload) {
    const http = new Http();
    const assetTypes = {
      [AssetTypes.TRANSFORMER]: 'transformador',
      [AssetTypes.CIRCUIT_BREAKER]: 'disjuntor',
      [AssetTypes.DISCONNECTOR]: 'seccionadora',
    };
    const mappedPayload = new AssetsRelationPagedRequest(payload);
    return http.post(urls.getReports(assetTypes[assetType]), mappedPayload)
      .then(({ data }) => new AssetsRelationPagedResponse(data));
  },

  exportExcel(payload) {
    const mappedPayload = new AssetsRelationRequest(payload);
    const http = new Http({
      download: true,
      ...errorHandler,
    });
    return http
      .post(urls.excel, mappedPayload)
      .then(({ data }) => data);
  },
};
